class CoverageCapital {
  sumInsured: string
  constructor(data: any) {
    this.sumInsured = data.sumInsured
  }
}

export default class CoverageBasic {
  coverageCode: string
  coverageNumber: string
  title: string // from DXP
  shortDescription?: string // from DXP
  description: string
  tooltip: string // from DXP
  mandatory: boolean
  maxAge: number
  minAge: number
  coverageInfoCapitals: CoverageCapital[]

  constructor(data: CoverageBasic) {
    this.coverageCode = data.coverageCode
    this.coverageNumber = data.coverageNumber
    this.title = data.title
    this.shortDescription = data.shortDescription
    this.description = data.description
    this.tooltip = data.tooltip
    this.mandatory = data.mandatory
    this.maxAge = data.maxAge
    this.minAge = data.minAge
    this.coverageInfoCapitals = data.coverageInfoCapitals.map(
      (c: CoverageCapital) => new CoverageCapital(c)
    )
  }
}
